import { useGeneralFlagStore } from '@/stores/generalFlagStore';
import { useGeneralStore } from '@/stores/generalStore';
// import { storeToRefs } from 'pinia';

// const { genericInfoModal } = storeToRefs(useGeneralStore());

/**
 * Opens the generic info modal with the given message and title.
 * @param message Message to display. Mandatory.
 * @param title Popup header. Optional.
 */
const showGenericInfoModal = function (message: string, title?: string) {
  if (title) {
    useGeneralStore().genericInfoModal.header = title;
  }
  useGeneralStore().genericInfoModal.message = message;

  useGeneralFlagStore().openGenericInfoModal();
};

/**
 * Closes the generic info modal and clears the title and message variables.
 */
const closeGenericInfoModal = function () {
  useGeneralFlagStore().closeGenericInfoModal();
};

export default {
  showGenericInfoModal,
  closeGenericInfoModal,
};
